import { useTranslation } from 'react-i18next';
import { Icon } from '@/shared/ui/icon';

/**
 * Jednotná hláška „Přístup odepřen". Renderuje se místo obsahu agendy, na který
 * přihlášený uživatel nemá oprávnění (viz {@link PermissionGate}). Vyplní celou
 * plochu hostujícího kontejneru a vycentruje sdělení.
 */
export function AccessDenied() {
  const { t } = useTranslation('errors');

  return (
    <div
      className="gap-phx-3 p-phx-6 flex h-full min-h-[40vh] flex-col items-center justify-center text-center"
      data-testid="access-denied"
    >
      <Icon name="lock" size={32} className="text-phx-text-muted" />
      <h2 className="text-phx-text text-lg font-semibold">{t('accessDenied.title')}</h2>
      <p className="text-phx-text-2 max-w-md text-sm">{t('accessDenied.description')}</p>
    </div>
  );
}
